<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>I wish to thank John and Amanda Peters, Annette and Newton Moraes for their invaluable help; they were the cornerstone of the project, without which or whom, this book would not have been possible.</p>
<p>I acknowledge the input from the following books, periodicals and papers used as background material in this book:</p>
<p>A History of Agriculture—Franklin.</p>
<p>Astronomy Data Book—Robinson and Muirden.</p>
<p>Atlas of the Earth—Caxton.</p>
<p>Biographical Dictionary—W &amp; R Chambers Ltd.</p>
<p>Catechism of the Catholic Church—G Chapman.</p>
<p>Chronicle of the Popes—P G Maxwell-Stuart.</p>
<p>Chronicle of the 20th Century—Chronicle Communications Ltd.</p><br/>
<p>Contributors on the Internet:</p>
<p>Encyclopaedia of the Earth—Hutchinson.</p>
<p>Energy: The Solar-Hydrogen Alternative—J O M Bockris.</p>
<p>Father John Lee’s Homily of 23 July 2017</p>
<p>Faster than the speed of light—Joao Magueijo.</p>
<p>Farming Technique from Prehistoric to Modern Times—G E Fossell.</p>
<p>Guinness Book of Air Facts and Feats—J &amp; M Taylor and D. Mondey</p>
<p>Guinness Book of Astronomy—Patrick Moore.</p>
<p>Guinness Encyclopaedia of the Living World.</p>
<p>Medicine through the Ages—P. Mantin &amp; R. Pulley</p>
<p>New Scientist—Reed Business Information Ltd.</p>
<p>Science and Invention—Cavendish Ltd.</p>
<p>State of the World—G. Gardner and P Sampat.</p>
<p>The British Broadcasting Corporation.</p>
<p>The Cambridge Encyclopaedia of Human Evolution.</p>
<p>The Evolving Continents—Brian Windley.</p>
<p>The Good News Bible—Collins.</p>
<p>The Guinness Book of Air Facts and Feats—J W R Taylor, M J H Taylor and D Mondey.</p>
<p>The Inventions that Changed the World—Readers Digest.</p>
<p>The Maidenhead Reference Library and its staff.</p>
<p>The Mill Hill Missions/ Maidenhead Missionaries.</p>
<p>The New Atlas of the Universe—Patrick Moore.</p>
<p>The New Jerusalem Bible—Darton, Longman &amp; Todd Ltd.</p>
<p>The Origin of Humankind—Stephen Thomkins.</p>
<p>The Spectator.</p>
<p>The Tablet.</p>
<p>The Times Concise Atlas of the World.</p>
<p>The Weather Book—M Joseph Ltd.</p>
<p>The World’s Great Religions—Collins (A “Life” Special Edition).</p>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch003.vue?359233b1